import store from 'store2'

import post from './post'

export function validate(done){

  var ombStore = store.namespace('omb')

  var token = ombStore('token')

  if(!token){
    done({error: 'no token found'})
  } else {
    post(
      'auth',
      {
        type: 'validate',
        token: token,
      },
      function(error,result){
        if(error){
          done(error)
        } else {
          done()
        }
      },
    )
  }

}

export function login(email,password,done){

  if(!email || !password){
    done({error: 'email and password required'})
  } else {
    post(
      'auth',
      {
        type: 'login', 
        email: email, 
        password: password
      }, 
      function(error, result){
        if(error){
          done(error,result)
        } else {
          done(null,result)
        }
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/client/lib/auth.js